import React from "react";
import OurCentersSection from "../../Sections/OurCentersSection/Content";
const OurCentersPage = () => {
  return <OurCentersSection />;
};

export default OurCentersPage;
